// extracted by mini-css-extract-plugin
export default {"card":"unknownProduct_card__7Lflf","info":"unknownProduct_info__Bz36x","deleteButton":"unknownProduct_deleteButton__wV5yF","image":"unknownProduct_image__J9YY4"};